import { useCallback, useState } from 'react'
import { HallType } from '@weblite/ts-action/hall'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { showChooseGroupCallDialog } from '$comp/modals/create-hall-call/choose-call-type/choose-group-call'
import {
  HallCallTime,
  HallCallType,
  showChooseHallCallTimeDialog,
} from '$comp/modals/create-hall-call/choose-call-time'
import { callService, getDefaultCallTitle } from '$logic/call'
import { useRoomAttribute } from '$logic/room'
import { useHall } from '$logic/hall/react-hook'
import { useClientUserPermissions } from '$logic/subscription/react-hook'

interface Props {
  roomId: string
  hallType: HallType
}

export function useStartCall({ roomId, hallType }: Props) {
  const [startingCall, setStartingCall] = useState(false)
  const call = useRoomAttribute('call', roomId)

  const userPermissions = useClientUserPermissions(roomId)

  const canStartCall = userPermissions?.isAdmin || userPermissions?.isOwner
  const { entity: hall } = useHall(roomId)

  const openChooseCallTimeDialog = useCallback(
    async (callType: HallCallType, onBack: () => unknown) => {
      const defaultTitle = getDefaultCallTitle(hall?.name || '', callType)
      const { time, shouldSendNotificationMessage, title, shouldStartNow } =
        (await showChooseHallCallTimeDialog({
          callType,
          onBack,
          // hallType,
          titlePlaceholder: defaultTitle,
        })) as HallCallTime

      setStartingCall(true)

      if (shouldStartNow)
        callService
          .startCall(roomId, hallType, callType, title || defaultTitle)
          .finally(() => {
            setStartingCall(false)
          })
      else
        callService
          .scheduleCall({
            roomId,
            roomType: hallType,
            callType,
            callTime: time,
            name: title || defaultTitle,
            shouldSendNotification: shouldSendNotificationMessage,
          })
          .finally(() => {
            setStartingCall(false)
          })
    },
    [roomId, hallType, hall],
  )

  const openChooseCallDialog = useCallback(async () => {
    const callType =
      hallType === 'CHANNEL'
        ? ('classroom' as HallCallType)
        : await showChooseGroupCallDialog()

    void openChooseCallTimeDialog(callType, async () => {
      await closeCurrentModal()
      // void openChooseCallDialog()
    })
  }, [hallType, openChooseCallTimeDialog])

  return { openChooseCallDialog, startingCall, call, canStartCall }
}
